import React from "react";
import { Box, Grid } from "@mui/material";

export default ({ node }) => {
  const { htmlText } = node;

  return (
    <Box>
      <Grid container>
        <Grid item xs={12}>
          {htmlText ? (
            <div dangerouslySetInnerHTML={{ __html: htmlText }} />
          ) : (
            ""
          )}
        </Grid>
      </Grid>
    </Box>
  );
};
